import React from "react";
import ReactDOM from "react-dom";
import {
  Form,
  FormElement,
  FormValidator,
  CustomTextControl,
  BaseReactComponent,
  SelectControl,
} from "../../utils/form";
import DatePicker from "react-datepicker";
import { connect } from "react-redux";
import { getKeywordNameApi } from '../MasterCategory/Api';
import { Row, Col, Button } from "react-bootstrap";
import { ClearButton, ComponentHeader, SelectKeywords, Spinner } from "../common";
import { addCampaignAdsApi, getAllCampaignApi, updateCampaignAdsApi } from "./Api";
import moment from "moment";
import { toast } from "react-toastify";
import { getAdminUser, getSafeArray, isPartnerAllowed } from "../../utils/ReusableFunctions";
import { getAllSsoPartnersApi } from "../sso/Api";
import { isModuleExist, MAX_LIMIT, MODULE_ID_MAP, publishOptions } from "../../utils/Constant";
import { withRouter } from "../../utils/hoc/withRouter";

class CampaignAdsForm extends BaseReactComponent {
  constructor(props) {
    super(props);
    // const data = props.editData || null;
    const data = props?.location?.state?.editData || null;
    const AccesData = isModuleExist(MODULE_ID_MAP.AdsCampaignAd);

    let partners = this.loadDefaultPartners(AccesData)
    if (data?.partners?.list) {
      partners = data?.partners
    }
    this.state = {
      AccessData: AccesData,
      partners,
      editData: data,
      campaignAdName: data?.campaignAdName || "",
      adType: data?.adType || "",
      search: "",
      keywords: data?.keywords || [],
      campaign: data?.campaign?.uuid || '',
      position: data?.position || "",
      startDate: data?.startDate ? new Date(data?.startDate) : "",
      endDate: data?.endDate ? new Date(data?.endDate) : "",
      isAddContent: true,
      campaignOption: [],
      keywordOption: [],
      resLoading: false,
      pageSize: MAX_LIMIT,
      adCategory: data?.adCategory || ""
    };
  }

  componentDidMount() {
    this.props.getKeywordNameApi(this);
    this.props.getAllCampaignApi(this)
    getAllSsoPartnersApi(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.search !== prevState.search) {
      this.props.getKeywordNameApi(this);
    }
  }

  onSubmit = () => {
    ReactDOM.findDOMNode(this.form).dispatchEvent(
      new Event("submit", { cancelable: true, bubbles: true })
    );
  }

  onValidSubmit = () => {
    this.setState({ resLoading: true })
    if (this.state.startDate && this.state.endDate) {
      let campaignAdData = {
        "data": {
          "campaignAdName": this.state.campaignAdName,
          "keywords": this.state.keywords,
          "position": parseInt(this.state.position),
          "startDate": this.state.startDate,
          "campaign": { "uuid": this.state.campaign },
          "adType": this.state.adType,
          "endDate": this.state.endDate,
          "adCategory": this.state.adCategory,
          'partners': this.state.partners,

        }
      };
      if(!isPartnerAllowed(this.state.AccessData?.id)){
      delete campaignAdData.data.partners;
    }

      if (this.state.editData?.uuid) {
        updateCampaignAdsApi(campaignAdData, this.props.this, this.props.onHide, this.state.editData.uuid, this)
      } else {
        addCampaignAdsApi(campaignAdData, this.props.this, this.props.onHide, this)
      }
    } else {
      toast.error('Select start and end date.')
    }

  }
  onHide = () => {
    this.props.getAllCampaignApi();
    this.props.onHide();
  }
  render() {
    const { campaignOption, resLoading, editData } = this.state;
    return (
      <section className="add-section">

        <ComponentHeader
          title={editData?.uuid ? "Edit Campaign Ads" : "Add Campaign Ads"}
          // primaryBtn={false}
          breadcrumb={[["Ads", ""], ["Campaign Ads", "/campaign-ads"],[editData?.uuid ? "Edit Campaign Ads" : "Add Campaign Ads", ""]]}
          isBackArrow={true}
          isReturn={'/campaign-ads'}
        />
        <Form ref={el => this.form = el} onValidSubmit={() => this.onValidSubmit()}>
          <Row>
            {isPartnerAllowed(this.state.AccessData?.id) && 
            <Col md={4}>
              <FormElement
                valueLink={this.linkState(this, "partners.list")}
                label="Publish To Partner(s)"
                required
                validations={[
                  {
                    validate: FormValidator.isRequired,
                    message: "Publish To cannot be empty",
                  },
                ]}
                control={{
                  type: SelectControl,
                  settings: {
                    options: this.state?.ssoPartnersOptions || [],
                    placeholder: "Select Partner(s)",
                    multiple: true,
                    searchable: true,
                    selectAll: true,
                    onChangeCallback: (onBlur) => {
                    },
                  },
                }}
              />

            </Col>}
            <Col sm={4}>
              <FormElement
                valueLink={this.linkState(this, "campaignAdName")}
                label="Campaign Ad Name"
                required
                validations={[
                  {
                    validate: FormValidator.isRequired,
                    message: "Field cannot be empty",
                  },
                ]}
                control={{
                  type: CustomTextControl,
                  settings: {
                    //   type: "",
                    placeholder: "Enter Campaign Ads Name",
                  },
                }}
              />
            </Col>
            <Col sm={4}>
              <FormElement
                valueLink={this.linkState(this, "position")}
                label="Campaign Position"
                required
                validations={[
                  {
                    validate: FormValidator.isRequired,
                    message: "Field cannot be empty",
                  },
                ]}
                control={{
                  type: CustomTextControl,
                  settings: {
                    //   type: "",
                    placeholder: "Enter Position",
                  },
                }}
              />
            </Col>


            <Col md={4}>
              <FormElement
                valueLink={this.linkState(this, "adType")}
                label="Campaign Ad Type"
                required
                validations={[
                  {
                    validate: FormValidator.isRequired,
                    message: "Campaign type cannot be empty",
                  },
                ]}
                control={{
                  type: SelectControl,
                  settings: {
                    placeholder: "Select Type",
                    options: [
                      {
                        value: 'FEATURED',
                        label: "Featured",
                      },
                      {
                        value: 'AD',
                        label: "Ad",
                      },

                    ],
                    multiple: false,
                    searchable: true,
                    onChangeCallback: (onBlur) => {
                      onBlur(this.state.adType);
                    },
                  },
                }}
              />
            </Col>

            <Col md={4}>
              <FormElement
                valueLink={this.linkState(this, "campaign")}
                label="Select Campaign"
                required
                validations={[
                  {
                    validate: FormValidator.isRequired,
                    message: "Campaign type cannot be empty",
                  },
                ]}
                control={{
                  type: SelectControl,
                  settings: {
                    placeholder: "Select Campaign",
                    options: campaignOption,
                    multiple: false,
                    searchable: true,
                    onChangeCallback: (onBlur) => {
                      onBlur(this.state.campaign);
                    },
                  },
                }}
              />
            </Col>
            <Col md={4}>
              <FormElement
                valueLink={this.linkState(this, "adCategory")}
                label="Select Ad Category"
                required
                validations={[
                  {
                    validate: FormValidator.isRequired,
                    message: "Ad Category cannot be empty",
                  },
                ]}
                control={{
                  type: SelectControl,
                  settings: {
                    placeholder: "Select Category",
                    options: [{
                      value: "generic",
                      label: "Generic",
                    },
                    {
                      value: "keyword",
                      label: "Keyword",
                    }],
                    multiple: false,
                    searchable: true,
                    onChangeCallback: (onBlur) => {
                      onBlur(this.state.adCategory);
                    },
                  },
                }}
              />
            </Col>
            {this.state.adCategory === "keyword" && <Col md={4}>
              <SelectKeywords label="Keywords" placeholder={'Enter Keywords'} onchangeHandler={(data) => this.setState({ search: data })} options={this.state.keywordOption} selectedKeyWords={this.state.keywords} getKeys={(data) => this.setState({ keywords: data })} />
            </Col>}
            <Col md={4}>
              <div className="form-group custom-date-range-picker">
                <label htmlFor="" className="form-label">Ad Start Date</label>
                <DatePicker
                  selected={this.state.startDate}
                  onChange={(date) => this.setState({ startDate: date })}
                  maxDate={this.state.endDate}
                  minDate={moment().toDate()}
                  showTimeSelect
                  // filterTime={filterPassedTime}
                  dateFormat="MMMM d, yyyy h:mm aa"
                  // dateFormat="dd/MM/yyyy"
                  placeholderText="Ad Start Date"
                  className="form-control "
                  // showMonthDropdown
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={50}
                  scrollableYearDropdown
                />
              </div>
            </Col>
            <Col md={4}>
              <div className="form-group custom-date-range-picker">
                <label htmlFor="" className="form-label">Ad End Date</label>
                <DatePicker
                  selected={this.state.endDate}
                  onChange={(date) => this.setState({ endDate: date })}
                  // minDate={this.state.startDate}
                  showTimeSelect
                  minDate={this.state.startDate || moment().subtract(1, 'days').toDate()}
                  // filterTime={filterPassedTime}
                  dateFormat="MMMM d, yyyy h:mm aa"
                  // dateFormat="dd/MM/yyyy"
                  placeholderText="Ad End Date"
                  className="form-control "
                  // showMonthDropdown
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={50}
                  scrollableYearDropdown
                />
              </div>
            </Col>
          </Row>

          <div className="submit-wrapper" style={{ justifyContent: "center" }}>

            <Button className="primary-btn" onClick={() => this.onSubmit()}>
              {resLoading ? <span className="d-flex align-items-center gap-12"> <Spinner /> Saving...</span> : "Save"}
            </Button>
          </div>
        </Form>
        {/* </CustomModal> */}
      </section>
    );
  }
}

const mapStateToProps = state => ({
  // masterCategoryState: state.MasterCategoryState,
});

const mapDispatchToProps = {
  getKeywordNameApi,
  getAllCampaignApi
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CampaignAdsForm));
